import React, { useContext, useEffect, useState, useRef } from "react";
import { CoreContext } from "context/CoreContext";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import {  
    SelectProfileContainer,
    SelectProfileTitle,
    SelectProfileSubtitle,
    BackToDashboardButton,
    ProfileContainer,
    ProfileItem,
    ProfileImage,
    ProfileName,
    AddProfileButton,
    EditProfileButton,
    ModalOverlay,
    ModalContent,
    ModalTitle,
    AvatarEditContainer,
    AvatarEditPreview,
    ChangeImageButton,
    ModalButtons,
    ModalButton
} from './styled';

import ContainerAuthenticated from "containers/Authenticated";
import { DeleteProfile, UpdateProfile, ReadProfiles } from "services/profile";
import { parseProfile } from "utils/parser";
import { UploadImage, PostImageAlternative } from "services/api";

export default function SelectProfile() { 
    const history = useHistory();
    const navigate = to => history.push(`/${to}`);
    const { profiles, setProfiles, setCurrentProfile, currentProfile } = useContext(CoreContext);
    const [loading, setLoading] = useState(false);
    
    // Estados para edição de perfil
    const [editingProfile, setEditingProfile] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [newAvatarFile, setNewAvatarFile] = useState(null);
    const [newAvatarPreview, setNewAvatarPreview] = useState('');
    const [uploadingImage, setUploadingImage] = useState(false);
    const fileInputRef = useRef(null);

    // Verificar se está no modo "gerenciar" (veio do menu)
    const isManageMode = window.location.search.includes('manage=true') || 
                        (currentProfile && currentProfile.id && profiles && profiles.length > 0);

    // Se já tiver um perfil atual selecionado E NÃO estiver no modo gerenciar, redireciona para dashboard
    useEffect(() => {
        if (currentProfile && currentProfile.id && !isManageMode) {
            navigate('dashboard');
        }
    }, [currentProfile, isManageMode]);

    const selectProfile = (profile) => {
        setCurrentProfile(profile);
        navigate('dashboard');
    };
    
    const createProfile = () => {
        navigate('dashboard/create-profile');
    };
    
    const editProfile = (profile) => {
        setEditingProfile(profile);
        setNewAvatarPreview(profile.avatar?.image || '/images/default-avatar.png');
        setShowEditModal(true);
    };
    
    const closeEditModal = () => {
        setShowEditModal(false);
        setEditingProfile(null);
        setNewAvatarFile(null);
        setNewAvatarPreview('');
    };
    
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setNewAvatarFile(file);
            const previewURL = URL.createObjectURL(file);
            setNewAvatarPreview(previewURL);
        }
    };
    
    const triggerFileInput = () => {
        fileInputRef.current.click();
    };
    
    const saveProfileChanges = async () => {
        if (!editingProfile) return;
        
        setUploadingImage(true);
        
                try {
             let pictureId = null;
             let uploadResult = null; // Declarar no escopo da função
             
             // Se uma nova imagem foi selecionada, fazer upload
             if (newAvatarFile) {
                 let uploadSuccessful = false;
                
                try {
                    // Tentar upload
                    uploadResult = await PostImageAlternative(newAvatarFile);
                    uploadSuccessful = true;
                } catch (uploadError) {
                    try {
                        uploadResult = await UploadImage(newAvatarFile);
                        uploadSuccessful = true;
                    } catch (altError) {
                        throw new Error('Falha no upload da imagem');
                    }
                }
                
                if (uploadSuccessful && uploadResult) {
                    const uploaded = Array.isArray(uploadResult) ? uploadResult[0] : uploadResult;
                    if (uploaded?.id) {
                        pictureId = uploaded.id;
                    }
                    if (uploaded?.url) {
                        setNewAvatarPreview(uploaded.url);
                    }
                }
            }
            
                         // Atualizar o perfil
             const updateData = {};
             if (pictureId) {
                 updateData.picture = pictureId;
             }
             
             if (Object.keys(updateData).length > 0) {
                 console.log('🔍 Atualizando perfil:', editingProfile.id, 'com dados:', updateData);
                 const updateResult = await UpdateProfile({ data: updateData }, editingProfile.id);
                 console.log('🔍 Resultado da atualização:', updateResult);
                 
                 // Recarregar perfis da API
                 console.log('🔍 Recarregando perfis...');
                 const updatedProfiles = await ReadProfiles();
                 console.log('🔍 Perfis atualizados recebidos:', updatedProfiles);
                 
                 // Verificar a estrutura da resposta e atualizar corretamente
                 if (updatedProfiles?.data?.length) {
                     console.log('🔍 Perfis têm .data, usando updatedProfiles.data');
                     setProfiles(updatedProfiles.data.map(parseProfile));
                 } else if (Array.isArray(updatedProfiles) && updatedProfiles.length > 0) {
                     console.log('🔍 Resposta é array direto, usando updatedProfiles');
                     setProfiles(updatedProfiles.map(parseProfile));
                                   } else {
                      console.log('🔍 Estrutura inesperada, forçando atualização local');
                      // Atualizar localmente como fallback
                      const newImageUrl = uploadResult && uploadResult[0]?.url;
                      if (newImageUrl) {
                          setProfiles(prevProfiles => 
                              prevProfiles.map(profile => 
                                  profile.id === editingProfile.id 
                                      ? { ...profile, avatar: { image: newImageUrl } }
                                      : profile
                              )
                          );
                      }
                  }
                  
                               // 🔄 GARANTIA DE ATUALIZAÇÃO: Força atualização da interface independentemente do backend
                  if (uploadResult && uploadResult[0]?.url) {
                      console.log('🔍 Forçando atualização otimista da interface');
                      const newImageUrl = uploadResult[0].url;
                      
                       setProfiles(prevProfiles => {
                           const updatedProfiles = prevProfiles.map(profile => 
                               profile.id === editingProfile.id 
                                   ? { 
                                       ...profile, 
                                       avatar: { image: newImageUrl }
                                     }
                                   : profile
                           );
                           console.log('🔍 Perfis atualizados localmente:', updatedProfiles);
                           return updatedProfiles;
                       });
                       
                       // Atualizar também o currentProfile se for o mesmo sendo editado
                       if (currentProfile && currentProfile.id === editingProfile.id) {
                           setCurrentProfile(prevProfile => ({
                               ...prevProfile,
                               avatar: { image: newImageUrl }
                           }));
                       }
                   }
                 
                 toast.success('Perfil atualizado com sucesso!');
             } else if (newAvatarFile) {
                 // Se não conseguiu atualizar no backend, mas tem nova imagem, atualizar localmente
                 const imageUrl = uploadResult[0]?.url;
                 if (imageUrl) {
                     setProfiles(prevProfiles => 
                         prevProfiles.map(profile => 
                             profile.id === editingProfile.id 
                                 ? { ...profile, avatar: { image: imageUrl } }
                                 : profile
                         )
                     );
                     toast.success('Imagem atualizada!');
                 }
             }
            
                         // Fechar modal com um pequeno delay para mostrar a atualização
             setTimeout(() => {
                 closeEditModal();
             }, 500);
        } catch (error) {
            console.error('Erro ao atualizar perfil:', error);
            toast.error('Erro ao atualizar perfil. Tente novamente.');
        } finally {
            setUploadingImage(false);
        }
    };
    
    const deleteProfile = async (profile) => {
        if (window.confirm(`Tem certeza que deseja excluir o perfil ${profile.name}?`)) {
            setLoading(true);
            try {
                await DeleteProfile(profile.id);
                toast.success('Perfil excluído com sucesso!');
                // Atualiza a lista de perfis
                setProfiles([]);
            } catch (error) {
                console.error('Erro ao excluir perfil:', error);
                toast.error('Erro ao excluir perfil.');
            } finally {
                setLoading(false);
            }
        }
    };



    const goBackToDashboard = () => {
        navigate('dashboard');
    };

    return (
        <ContainerAuthenticated primary page="SelectProfile">
            <SelectProfileContainer>
                <SelectProfileTitle>
                    {isManageMode ? 'Gerenciar Perfis' : 'Selecione seu Perfil'}
                </SelectProfileTitle>
                <SelectProfileSubtitle>
                    {isManageMode ? 'Escolha outro perfil ou edite os existentes' : 'Clique no seu avatar para começar'}
                </SelectProfileSubtitle>
                
                {isManageMode && (
                    <BackToDashboardButton onClick={goBackToDashboard}>
                        Voltar
                    </BackToDashboardButton>
                )}
                
                <ProfileContainer>
                    {profiles && profiles.length > 0 ? (
                        // Exibe perfis existentes
                        <>
                            {profiles.map((profile, index) => (
                                <ProfileItem key={index}>
                                    <ProfileImage
                                        image={profile.avatar?.image || profile.avatar || '/images/default-avatar.png'}
                                        onClick={() => selectProfile(profile)}
                                        active={isManageMode && currentProfile?.id === profile.id}
                                    />
                                    <ProfileName active={isManageMode && currentProfile?.id === profile.id}>
                                        {profile.name}
                                        {isManageMode && currentProfile?.id === profile.id && ' (Atual)'}
                                    </ProfileName>
                                    <EditProfileButton onClick={() => editProfile(profile)}>Editar</EditProfileButton>
                                    <EditProfileButton delete onClick={() => deleteProfile(profile)}>Excluir</EditProfileButton>
                                </ProfileItem>
                            ))}
                            {/* Uma assinatura, a família toda: até 3 crianças por conta */}
                            {profiles.length < 3 && (
                                <AddProfileButton onClick={createProfile}>
                                    <span>+</span>
                                    <p>Adicionar criança</p>
                                </AddProfileButton>
                            )}
                        </>
                    ) : (
                        // Exibe botão para criar perfil se não existir nenhum
                        <AddProfileButton onClick={createProfile}>
                            <span>+</span>
                            <p>Criar perfil</p>
                        </AddProfileButton>
                    )}
                </ProfileContainer>
            </SelectProfileContainer>
            
            {/* Modal de edição de perfil */}
            {showEditModal && editingProfile && (
                <ModalOverlay onClick={closeEditModal}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        <ModalTitle>Editar Perfil</ModalTitle>
                        
                        <AvatarEditContainer>
                            <AvatarEditPreview image={newAvatarPreview} />
                            <ChangeImageButton onClick={triggerFileInput}>
                                Trocar Imagem
                            </ChangeImageButton>
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                accept="image/*"
                                style={{ display: 'none' }}
                            />
                        </AvatarEditContainer>
                        
                        <ModalButtons>
                            <ModalButton onClick={closeEditModal}>
                                Cancelar
                            </ModalButton>
                            <ModalButton 
                                primary 
                                onClick={saveProfileChanges}
                                disabled={uploadingImage}
                            >
                                {uploadingImage ? 'Salvando...' : 'Salvar'}
                            </ModalButton>
                        </ModalButtons>
                    </ModalContent>
                </ModalOverlay>
            )}
        </ContainerAuthenticated>
    );
}